<div class="search-advanced-items">
  <div class="search-advanced-pane blue">
    <div class="filter-section">
      <div class="section-title-container">
        <h2 class="section-title gradient-title text-align-center">
          Settings
        </h2>
      </div>

      <div class="filter-group">
        <div class="filter-group-header">
          <div class="filter">
            <span class="input-group-btn">
              <button class="btn toggle-btn caret-btn" [class.off]="!settings.settingsGroupVisibility().general"
                (click)="settings.toggleSettingsGroupVisibility('general')"></button>
            </span>
            <span class="filter-body">
              <span filter-title text="General">
              </span>
            </span>
          </div>
        </div>

        <div class="filter-group-body" [class.collapsed]="!settings.settingsGroupVisibility().general">
          <div class="filter filter-property full-span">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!settings.autoPreviewPresetChanges()"
                (click)="settings.toggleAutoPreviewPresetChanges()"></button>
            </span>
            <span class="filter-body">
              <span filter-title text="Automatically preview changes upon changing presets">
                When enabled, shows the preview dialog when switching Class or Progress Presets, but only if you have made manual changes to settings affected by the preset. Use the preview icon on a preset to review changes at any time.
              </span>
            </span>
          </div>

          <div class="filter filter-property full-span">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!settings.skipRemoveConfirmDialogs()"
                (click)="settings.toggleSkipRemoveConfirmDialogs()"></button>
            </span>
            <span class="filter-body">
              <span filter-title text="Skip confirmation dialog when removing or deleting items">
                Applies to e.g. removing rules, rule groups, equipment types, and custom mod categories. Less commonly used dangerous actions still require confirmation.
              </span>
            </span>
          </div>

          <div class="filter filter-property full-span">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!settings.limitGearTierListToMyGear()"
                (click)="settings.toggleLimitGearTierListToMyGear()"></button>
            </span>
            <span class="filter-body">
              <span filter-title text="Limit Gear Tier List to Favourite Gear only">
                Limits the Item Class and Defence Type dropdowns on the Gear Tier List to gear configured in Favourite Gear or Leveling Gear. Does not change the Filter Output.
              </span>
            </span>
          </div>

          <div class="filter filter-property full-span">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!settings.numericAlertSoundVolume()"
                (click)="settings.toggleNumericAlertSoundVolume()"></button>
            </span>
            <span class="filter-body">
              <span filter-title text="Use numeric input for Alert Sound volume">
                Replaces the Quiet / Default / Louder / Max dropdown with a 1-300 number field on cosmetic sound settings. Allows more fine-tuning.
              </span>
            </span>
          </div>
        </div>
      </div>

      <div class="filter-group">
        <div class="filter-group-header">
          <div class="filter">
            <span class="input-group-btn">
              <button class="btn toggle-btn caret-btn" [class.off]="!settings.settingsGroupVisibility().privacySharing"
                (click)="settings.toggleSettingsGroupVisibility('privacySharing')"></button>
            </span>
            <span class="filter-body">
              <span filter-title text="Privacy & Sharing">
              </span>
            </span>
          </div>
        </div>

        <div class="filter-group-body" [class.collapsed]="!settings.settingsGroupVisibility().privacySharing">
          <div class="filter filter-property full-span">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!settings.filterSnapshotStorageEnabled()"
                (click)="toggleFilterSnapshotStorage()"></button>
            </span>
            <span class="filter-body">
              <div class="filter-title">
                <span class="filter-title-text">Store filter configurations to help improve the filter for everyone</span>
                <span class="extra-info settings-help-link" (click)="showFilterSnapshotLearnMore = true"> (?)</span>
              </div>
            </span>
          </div>

          <div class="filter filter-property full-span" [class.disabled]="!settings.filterSnapshotStorageEnabled()">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!settings.filterSnapshotUsernameEnabled()"
                [disabled]="!settings.filterSnapshotStorageEnabled()"
                (click)="toggleFilterSnapshotUsername()"></button>
            </span>
            <span class="filter-body">
              <div class="filter-title">
                <span class="filter-title-text">Allow storing my PoE username with filter snapshots</span>
                <span class="extra-info settings-help-link" (click)="showFilterSnapshotLearnMore = true"> (?)</span>
              </div>
            </span>
          </div>

          <div class="filter filter-property full-span">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!settings.filterShareLinkUsernameEnabled()"
                (click)="settings.toggleFilterShareLinkUsername()"></button>
            </span>
            <span class="filter-body">
              <div class="filter-title">
                <span class="filter-title-text">Include my PoE username in filter share links</span>
              </div>
            </span>
          </div>
        </div>
      </div>

      <div class="filter-group">
        <div class="filter-group-header">
          <div class="filter">
            <span class="input-group-btn">
              <button class="btn toggle-btn caret-btn" [class.off]="!settings.settingsGroupVisibility().display"
                (click)="settings.toggleSettingsGroupVisibility('display')"></button>
            </span>
            <span class="filter-body">
              <span filter-title text="Display">
              </span>
            </span>
          </div>
        </div>

        <div class="filter-group-body" [class.collapsed]="!settings.settingsGroupVisibility().display">
          <div class="filter filter-property full-span">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!settings.showValueInDropdowns()"
                (click)="settings.toggleShowValueInDropdowns()"></button>
            </span>
            <span class="filter-body">
              <div class="filter-title">
                <span class="filter-title-text">Show values of currency items in dropdowns</span>
              </div>
            </span>
          </div>

          <div class="filter filter-property full-span">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!settings.hideIconsInDropdowns()"
                (click)="settings.toggleHideIconsInDropdowns()"></button>
            </span>
            <span class="filter-body">
              <span filter-title text="Hide icons in dropdowns">
                On small screens, icons will always be shown instead of text.
              </span>
            </span>
          </div>

          <div class="filter filter-property full-span">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!settings.autocompleteRetainSearch()"
                (click)="settings.toggleAutocompleteRetainSearch()"></button>
            </span>
            <span class="filter-body">
              <span filter-title text="Keep search text when selecting dropdown items">
                Makes it easier to select multiple matching items, e.g. type &quot;greater&quot; and select multiple Greater Essences.
              </span>
            </span>
          </div>

          <div class="filter filter-property full-span">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!settings.highlightStats()"
                (click)="settings.toggleHighlightStats()"></button>
            </span>
            <span class="filter-body">
              <div class="filter-title">
                <span class="filter-title-text">Highlight numerical values of stats on all item detail tooltips</span>
              </div>
            </span>
          </div>

          <div class="filter filter-property full-span">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!settings.includeCritInWeaponDps()"
                (click)="settings.toggleIncludeCritInWeaponDps()"></button>
            </span>
            <span class="filter-body">
              <span filter-title text="Include critical strike chance in weapon DPS">
                Counts 50% extra damage on critical strikes (base crit multiplier).
              </span>
            </span>
          </div>

          <div class="filter filter-property full-span">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!settings.keepItemLabelTooltipsOpenOnHover()"
                (click)="settings.toggleKeepItemLabelTooltipsOpenOnHover()"></button>
            </span>
            <span class="filter-body">
              <div class="filter-title">
                <span class="filter-title-text">Keep item label tooltips open when hovering over the tooltip</span>
              </div>
            </span>
          </div>

          @if (poe1) {
            <div class="filter filter-property full-span">
              <span class="input-group-btn">
                <button class="btn toggle-btn" [class.off]="!settings.showUniquesDustValuePerSlot()"
                  (click)="settings.toggleShowUniquesDustValuePerSlot()"></button>
              </span>
              <span class="filter-body">
                <div class="filter-title">
                  <span class="filter-title-text">Show uniques dust value per slot instead of total dust value</span>
                </div>
              </span>
            </div>
          }

          @if (poe2) {
            <div class="filter filter-property filter-padded-left" style="width: 100%">
              <span class="filter-body">
                <span filter-title text="Item label glow">
                  Simulates the in-game glow effect on item labels when you approach an item while playing with the keyboard or a controller.
                </span>
                <span class="sep"></span>
                <app-select style="width: 160px" [ngModel]="settings.labelGlow()" (selectedValueChange)="settings.setLabelGlow($event)">
                  <app-option value="always" text="Always"></app-option>
                  <app-option value="hover" text="On hover"></app-option>
                  <app-option value="never" text="Never"></app-option>
                </app-select>
              </span>
            </div>
          }
        </div>
      </div>

      <div class="filter-group">
        <div class="filter-group-header">
          <div class="filter">
            <span class="input-group-btn">
              <button class="btn toggle-btn caret-btn" [class.off]="!settings.settingsGroupVisibility().navigationLayout"
                (click)="settings.toggleSettingsGroupVisibility('navigationLayout')"></button>
            </span>
            <span class="filter-body">
              <span filter-title text="Navigation & Layout">
              </span>
            </span>
          </div>
        </div>

        <div class="filter-group-body" [class.collapsed]="!settings.settingsGroupVisibility().navigationLayout">
          <div class="filter filter-property full-span">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!settings.quickFiltersAsMainTab()"
                (click)="settings.toggleQuickFiltersAsMainTab()"></button>
            </span>
            <span class="filter-body">
              <div class="filter-title">
                <span class="filter-title-text">Set Quick Filters tab as main tab instead of Presets tab</span>
              </div>
            </span>
          </div>

          <div class="filter filter-property full-span">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!settings.autoViewChangelog()"
                (click)="settings.toggleAutoViewChangelog()"></button>
            </span>
            <span class="filter-body">
              <div class="filter-title">
                <span class="filter-title-text">Automatically open Changelog tab when there is a new version</span>
              </div>
            </span>
          </div>

          @if (poe1) {
            <div class="filter filter-property full-span">
              <span class="input-group-btn">
                <button class="btn toggle-btn" [class.off]="!settings.showExtraTab()"
                  (click)="settings.toggleShowExtraTab()"></button>
              </span>
              <span class="filter-body">
                <div class="filter-title">
                  <span class="filter-title-text">Show the Extra tab</span>
                </div>
              </span>
            </div>
          }

          <div class="filter filter-property full-span">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!settings.stickyNavigation()"
                (click)="settings.toggleStickyNavigation()"></button>
            </span>
            <span class="filter-body">
              <div class="filter-title">
                <span class="filter-title-text">Enable sticky navigation tabs</span>
              </div>
            </span>
          </div>

          <div class="filter filter-property full-span">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!settings.floatingControls()"
                (click)="settings.toggleFloatingControls()"></button>
            </span>
            <span class="filter-body">
              <div class="filter-title">
                <span class="filter-title-text">Enable floating action bar</span>
              </div>
            </span>
          </div>

          <div class="filter filter-property full-span">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!settings.enableRuleNavigation()"
                (click)="settings.toggleEnableRuleNavigation()"></button>
            </span>
            <span class="filter-body">
              <span filter-title text="Enable Rule Navigation">
                Enable <span class="keys"><span class="key">Ctrl</span></span>-Clicking on a rule title to navigate to the rule in the Filter Output, and vice-versa. Disabling improves tool performance.
              </span>
            </span>
          </div>
        </div>
      </div>

      <div class="filter-group">
        <div class="filter-group-header">
          <div class="filter">
            <span class="input-group-btn">
              <button class="btn toggle-btn caret-btn" [class.off]="!settings.settingsGroupVisibility().economyUpdates"
                (click)="settings.toggleSettingsGroupVisibility('economyUpdates')"></button>
            </span>
            <span class="filter-body">
              <span filter-title text="Economy Updates">
              </span>
            </span>
          </div>
        </div>

        <div class="filter-group-body" [class.collapsed]="!settings.settingsGroupVisibility().economyUpdates">
          <div class="filter filter-property filter-padded-left" style="width: 100%">
            <span class="filter-body">
              <span filter-title text="Behaviour on launch">
                Determines what happens when the tool is launched and the economy was updated since your last visit.
                <br /><br /><strong>Sync</strong> means that upon receiving economy updates, we'll not only update all values, but also synchronize those changes to your account automatically (if you're logged in), or save them to your game folder (if you have selected one). All that's left to do is refresh in-game.
                <br /><br />The <strong>Show</strong> checkbox will additionally take you to the Changelog page, where you are presented with a list of changes.
              </span>
              <span class="sep"></span>
              <app-select style="width: 200px" [ngModel]="settings.ecoUpdateBehaviorLaunch()" (selectedValueChange)="settings.setEcoUpdateBehaviorLaunch($event)">
                <app-option [value]="EcoUpdateBehavior.AutoUpdate" text="Auto Update"></app-option>
                <app-option [value]="EcoUpdateBehavior.AutoUpdateAndSync" text="Auto Update and Sync"></app-option>
              </app-select>
              @if (settings.ecoUpdateBehaviorLaunch() !== EcoUpdateBehavior.Inform) {
                <span class="sep"></span>
                <div class="filter-title filter-label table-checkbox-group">
                  <span class="input-group-btn">
                    <button class="btn toggle-btn" [class.off]="!settings.ecoUpdateBehaviorLaunchShowUpdates()"
                      (click)="settings.toggleEcoUpdateBehaviorLaunchShowUpdates()"></button>
                  </span>
                  <span class="table-checkbox-label">Show</span>
                </div>
              }
            </span>
          </div>

          <div class="filter filter-property full-span">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!settings.ecoUpdateBehaviorUpdateEnable()"
                (click)="settings.toggleEcoUpdateBehaviorUpdateEnable()"></button>
            </span>
            <span class="filter-body">
              <div class="filter-title">
                <span class="filter-title-text">Enable updates during session</span>
              </div>
            </span>
          </div>

          @if (settings.ecoUpdateBehaviorUpdateEnable()) {
            <div class="filter filter-property filter-padded-left" style="width: 100%">
              <span class="filter-body">
                <span filter-title text="Behaviour during session">
                  Determines what happens when the economy is updated during your session, as long as you have to tool open.
                  <br /><br />The <strong>Blink</strong> checkbox will show a blinking (or static, after a few minutes) blue timestamp of when the last economy update was received.
                </span>
                <span class="sep"></span>
                <app-select style="width: 200px" [ngModel]="settings.ecoUpdateBehaviorUpdate()" (selectedValueChange)="settings.setEcoUpdateBehaviorUpdate($event)">
                  <app-option [value]="EcoUpdateBehavior.Inform" text="Inform"></app-option>
                  <app-option [value]="EcoUpdateBehavior.AutoUpdate" text="Auto Update"></app-option>
                  <app-option [value]="EcoUpdateBehavior.AutoUpdateAndSync" text="Auto Update and Sync"></app-option>
                </app-select>
                <span class="sep"></span>
                <div class="filter-title filter-label table-checkbox-group">
                  <span class="input-group-btn">
                    <button class="btn toggle-btn" [class.off]="!settings.ecoUpdateBehaviorUpdateBlink()"
                      (click)="settings.toggleEcoUpdateBehaviorUpdateBlink()"></button>
                  </span>
                  <span class="table-checkbox-label">Blink</span>
                </div>
              </span>
            </div>
          }

          <div class="filter filter-property full-span">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!settings.hideMovedCurrencyUniques()"
                (click)="settings.toggleHideMovedCurrencyUniques()"></button>
            </span>
            <span class="filter-body">
              <div class="filter-title">
                <span class="filter-title-text">Never show Economy Updates on the Changelog</span>
              </div>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="search-advanced-pane blue">
    <div class="filter-section">
      <div class="section-title-container">
        <h2 class="section-title gradient-title text-align-center">
          Advanced Features
        </h2>
      </div>

      <div class="filter-group">
        <div class="filter-group-header">
          <div class="filter">
            <span class="input-group-btn">
              <button class="btn toggle-btn caret-btn" [class.off]="!settings.settingsGroupVisibility().advancedFeatures"
                (click)="settings.toggleSettingsGroupVisibility('advancedFeatures')"></button>
            </span>
            <span class="filter-body">
              <span filter-title text="Toggle Advanced Features">
              </span>
            </span>
          </div>
        </div>

        <div class="filter-group-body" [class.collapsed]="!settings.settingsGroupVisibility().advancedFeatures">
          <div class="filter filter-property full-span">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!settings.addMoreColorPresets()"
                (click)="toggleAddMoreColorPresets()"></button>
            </span>
            <span class="filter-body">
              <span filter-title text="Add more color presets">
                Adds an additional 6 colors to the Color Picker, and adds 'recently used' colors.
              </span>
            </span>
          </div>

          <div class="filter filter-property full-span">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!settings.enableCustomRuleGroups()"
                (click)="settings.toggleEnableCustomRuleGroups()"></button>
            </span>
            <span class="filter-body">
              <span filter-title text="Enable multiple Custom Rule Groups">
                Allows creating additional Custom & Custom Cosmetic Rule groups beyond the default group.
              </span>
            </span>
          </div>

          <div class="filter filter-property full-span">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!settings.enableCustomRuleLabels()"
                (click)="settings.toggleEnableCustomRuleLabels()"></button>
            </span>
            <span class="filter-body">
              <span filter-title text="Enable labels on Custom Rules">
              </span>
            </span>
          </div>

          <div class="filter filter-property full-span">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!settings.quickApplyRecentlyCopiedStylesInItemTierPicker()"
                (click)="settings.toggleQuickApplyRecentlyCopiedStylesInItemTierPicker()"></button>
            </span>
            <span class="filter-body">
              <span filter-title text="Paste from Style Library in Item Tier Picker">
                Adds a second row to the Item Tier Picker which allows you to paste any recent style from the Style Library to that item type with one click, or open the full library.
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="search-advanced-pane blue">
    <div class="filter-section">
      <div class="section-title-container">
        <h2 class="section-title gradient-title text-align-center">
          Label Preview Background
        </h2>
      </div>

      <div class="filter-group">
        <div class="label-preview-bg-section" [class.collapsed]="!settings.settingsGroupVisibility().labelPreviewBackground">
          <app-label-preview-background-picker
            [selectedId]="settings.labelPreviewBg()"
            (selected)="setLabelPreviewBg($event)" />
        </div>
      </div>
    </div>

    <div class="filter-section">
      <div class="section-title-container">
        <h2 class="section-title gradient-title text-align-center">
          Actions
        </h2>
      </div>

      <div class="row row-total row-justify-content-left">
        <div class="reset-buttons">
          <button type="button" class="btn" (click)="resetTutorials()">Reset All Tutorials</button>
          <button type="button" class="btn" (click)="resetAllWarningMessages()">Reset All Warnings and Explainers</button>
          <button type="button" class="btn" (click)="showChangeBgDialog = true">Change Background image</button>
          @if (supportsFileSystemAccess) {
            @if (showGameFolderHelp()) {
              <app-tooltip-wrapper class="game-folder-tooltip">
                <button type="button" class="btn" (click)="selectGameFolder()">Select game folder</button>
                <ng-template #tooltip>
                  Navigate to <span class="code">My Games\{{ gameName }}</span> in your Documents folder. You can also open this folder from the game's Settings menu under <strong>Game</strong>.
                </ng-template>
              </app-tooltip-wrapper>
            } @else {
              <button type="button" class="btn" (click)="selectGameFolder()">
                {{ gameFolderButtonText() }}
                @if (gameDirectoryName(); as dirName) {
                  <span class="extra-info">({{ dirName }})</span>
                }
              </button>
            }
          }
          @if (poe1) {
            <button type="button" class="btn" (click)="showRealmPicker = true">Change Realm <span class="extra-info">({{realm}})</span></button>
          }
        </div>
      </div>
    </div>
  </div>
</div>

@if (showChangeBgDialog) {
  <div class="dialog-backdrop"></div>
  <div class="tutorial center" style="display: flex !important;">
    <div class="tutorial-content center-text">
      <div class="tutorial-body">
        <p>
          Choose a background for the tool, or 'Zen mode' to remove the background.
        </p>

        <div class="tutorial-options background-picker-options poe-scrollbar">
          @for (img of images; track  img.src) {
            <div class="tutorial-option preset-option" [class.selected]="settings.bgImage() === img.src" (click)="setBackground(img)">
              <h3>{{ img.name }}</h3>
              @if (img.src !== 'zen') {
                <img class="tutorial-option-image" src="{{ assetBaseUrl }}/img/bg/small/{{ img.src }}-small.webp"/>
              }
            </div>
          }
        </div>

        <button type="button" class="btn close-tutorial-btn" (click)="closeChangeBgDialog()">
          Close
        </button>
      </div>
    </div>
  </div>
}

@if (showRealmPicker) {
  <app-realm-selector-dialog (close)="showRealmPicker = false; realm = $event"></app-realm-selector-dialog>
}

@if (showFilterSnapshotLearnMore) {
  <app-filter-snapshot-learn-more-dialog
    (allow)="allowFilterSnapshotStorage($event)"
    (optOut)="optOutFilterSnapshotStorage()"
    (close)="showFilterSnapshotLearnMore = false">
  </app-filter-snapshot-learn-more-dialog>
}
